import React from "react";
import { Page, Navbar, Row, Col, Toolbar, Button, Block } from "framework7-react";

const BidDetailPage = () => {
  return (
    <Page className="no-scroll bg-white " >
      <Navbar title="Bid Details" noShadow backLink="Back"/>
      <Block className="m-0">
        <Row className="mt-0 pt-2 bg-light">
          <Col width="15"><img
                  alt=""
                  slot="media"
                  src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg"
                  width="40"
                  className="rounded-circle"
              /></Col>
          <Col>Customer XYZ<br/><small>Today at 12:30 pm</small></Col>
          <Col><p className="text-end">Bid ID: <b>348</b><br/><small>Total: <b>$ 4526</b></small></p></Col>
        </Row>
      </Block>
      <Block className="m-0">
        <Row className="pt-2 pb-2 border-bottom bg-light">
          <Col><b>Items</b></Col>
          <Col className="text-center"><b>Quantity</b></Col>
          <Col className="text-end"><b>Price</b></Col>
        </Row>
        <Row className="pt-2 pb-2">
          <Col>Menu 1</Col>
          <Col className="text-center">Tray: 1</Col>
          <Col className="text-end">$ 56.00</Col>
        </Row>
        <Row className="pt-2 pb-2">
          <Col>Menu 2</Col>
          <Col className="text-center">Tray: 1</Col>
          <Col className="text-end">$ 59.00</Col>
        </Row>
        <Row className="pt-2 pb-2">
          <Col>Menu 3</Col>
          <Col className="text-center">Tray: 1</Col>
          <Col className="text-end">$ 159.00</Col>
        </Row>
        <p><b>Message</b> Hi, we need extra large packing, Delivery person need to come our location</p>
      </Block>
      <Block className="m-0 pt-2 mb-5">  
        <Row>
          <Col className="border-bottom px-3 pb-2 pt-2 bg-light"><b>Party Details</b></Col>
        </Row>
        <Row className="mt-2 text-2 px-1">
          <Col width={50}><b>Party Name:</b> Party XYZ</Col>
          <Col><b>Party Size:</b> 75</Col>
        </Row>
        <Row className="mt-2 text-2 px-1">
          <Col width={50}><b>Date:</b> 19 - 04 - 2023</Col>
          <Col><b>Confirm Date:</b> 19 - 05 - 2023</Col>
        </Row>
        <Row className="mt-2 text-2 px-1">
          <Col width={50}><b>Party Size:</b> Party XYZ</Col>
          <Col><b>Party Details</b></Col>
        </Row>
        <Row className="mt-2 text-2 px-1">
          <Col><b>Address:</b> 333, Sweeterwater, Springs Bid, Spring Valley, CA</Col>              
        </Row>        
      </Block>
      <Toolbar tabbar noShadow bottom className='toolbar-cart'>
        <Block className='block-cart'>
          <Row>
            <Col width="50" medium="25">
              <Button fill large color="red" className='mt-1'> Cancel Bid </Button>
            </Col>
            <Col width="50" medium="25">
              <Button fill large className='mt-1'> Accept Bid </Button>
            </Col>
          </Row>          
        </Block>        
      </Toolbar>
    </Page>
  );
};

export default BidDetailPage;